import { useMemo } from "react";
import { useQuery } from "urql";

import { graphql } from "@/__graphql__";

export default function useRelationProfile() {
  const [{ data, fetching: loading }] = useQuery({ query: RelationQuery });

  const isDealer = data?.relation?.isDealer;
  const locationMap = useMemo(() => {
    const locationsGroupedByRelation: Record<string, { name: string; locations: unknown[] }> = {};
    if (data === undefined || data.relation === null) return locationsGroupedByRelation;

    const relation = data.relation;
    locationsGroupedByRelation[relation.id] = {
      name: relation.name,
      locations: relation.locations,
    };

    relation.customers.forEach(relation_ => {
      locationsGroupedByRelation[relation_.id] = {
        name: relation_.name,
        locations: relation_.locations,
      };
    });

    return locationsGroupedByRelation;
  }, [data]);

  const locationList = useMemo(() => {
    return Object.values(locationMap).flatMap(value => value.locations);
  }, [locationMap]);

  const relationList = useMemo(() => {
    if (data === undefined || data.relation === null) return [];
    return [data.relation, ...data.relation.customers];
  }, [data]);

  return { loading, isDealer, relation: data?.relation ?? undefined, locationMap, locationList, relationList };
}

const RelationQuery = graphql(`
  query Hooks__UseRelationProfile__RelationQuery {
    relation {
      id
      name
      place
      afasCode
      isDealer
      customers {
        id
        name
        afasCode
        activeContract {
          id
          startingOn
          endingOn
        }
        locations {
          id
          name
          contactPersons {
            id
            contactPerson {
              id
              name
              emailAddresses
              phoneNumbers
            }
          }
          address {
            street
            postalCode
            city
            country
            coordinates {
              latitude
              longitude
            }
          }
        }
      }
      locations {
        id
        name
        contactPersons {
          id
          contactPerson {
            id
            name
            emailAddresses
            phoneNumbers
          }
        }
        address {
          street
          postalCode
          city
          country
          coordinates {
            latitude
            longitude
          }
        }
      }
    }
  }
`);
